import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import HistoryIcon from '@mui/icons-material/History';
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import { Dispatch, FunctionComponent, SetStateAction, useLayoutEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

interface Props {
  setBottomNavHeight: Dispatch<SetStateAction<number>>
}

const MobileBottomNav: FunctionComponent<Props> = (props: Props): JSX.Element => {
  const { setBottomNavHeight } = props

  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();

  const bottomBarRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (bottomBarRef.current) {
      setBottomNavHeight(bottomBarRef.current.clientHeight);
    }
  }, []);

  const routeToIndex: { [key: string]: number } = {
    "/": 0,
    "/history": 1,
    "/contacts": 2
  };

  const value = routeToIndex[location.pathname] ?? null;

  return (
    <>
      <Paper ref={bottomBarRef} sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
        <BottomNavigation
          showLabels
          value={value}
          onChange={(event, newValue) => {
            switch (newValue) {
              case 0:
                navigate("/");
                break;
              case 1:
                navigate("/history");
                break;
              case 2:
                navigate("/contacts");
                break;
              default:
                break;
            }
          }}
        >
          <BottomNavigationAction label={t("current.outstanding2")} icon={<AccessTimeFilledIcon />} onClick={() => navigate("/")} />
          <BottomNavigationAction label={t("history.title")} icon={<HistoryIcon />} onClick={() => navigate("/history")} />
          <BottomNavigationAction label={t("contacts.title")} icon={<AccountCircleIcon />} onClick={() => navigate("/contacts")} />
        </BottomNavigation>
      </Paper>
    </>
  )
}

export default MobileBottomNav